/**
 * SQLite admin routes (booking-service or admin-api-standalone): `/api/admin/*`
 *
 * - Dev: leave `VITE_ADMIN_API_URL` unset — Vite proxies `/api` → :3002 (see vite.config.js).
 * - Production: set `VITE_ADMIN_API_URL` at build time if the SPA is not behind a proxy
 *   that forwards `/api` to the admin API (same pattern as `VITE_BFF_API_URL`).
 */
export function getAdminApiBaseUrl() {
  if (typeof import.meta !== 'undefined' && import.meta.env?.VITE_ADMIN_API_URL) {
    return String(import.meta.env.VITE_ADMIN_API_URL).replace(/\/$/, '');
  }
  return '';
}

/** @param {string} path Must start with / (e.g. /api/admin/email-send-logs) */
export function adminApiUrl(path) {
  const base = getAdminApiBaseUrl();
  const p = path.startsWith('/') ? path : `/${path}`;
  if (!base) return p;
  return `${base}${p}`;
}
